@if (pendingAttachments().length > 0) {
  <div class="flex gap-2 mt-3 pt-2 border-t border-gray-200 overflow-x-auto pb-1">
    @for (attachment of pendingAttachments(); track attachment.localId) {
      <div
        class="relative group rounded-lg overflow-hidden border border-gray-200 bg-white cursor-pointer shrink-0"
        [class.border-red-300]="attachment.uploadState === 'error'"
        (click)="openPreview(attachment)"
      >
        @if (isPdf(attachment.mimeType)) {
          <!-- PDF preview -->
          <div
            class="w-16 h-16 flex flex-col items-center justify-center bg-gray-50 text-gray-500"
          >
            <lucide-icon [img]="icons.FileText" class="w-6 h-6"></lucide-icon>
            <span class="text-[10px] mt-1 truncate max-w-[56px] px-1">{{
              attachment.fileName
            }}</span>
          </div>
        } @else {
          <!-- Image preview -->
          @if (attachment.previewUrl || attachment.signedUrl) {
            <img
              [src]="attachment.signedUrl || attachment.previewUrl"
              [alt]="attachment.fileName"
              class="w-16 h-16 object-cover"
            />
          } @else {
            <div
              class="w-16 h-16 flex items-center justify-center bg-gray-100"
            >
              <lucide-icon
                [img]="icons.Loader2"
                class="w-5 h-5 animate-spin text-gray-400"
              ></lucide-icon>
            </div>
          }
        }

        <!-- Upload progress overlay -->
        @if (attachment.uploadState === 'uploading') {
          <div
            class="absolute inset-0 bg-black/40 flex items-center justify-center"
          >
            <div class="text-white text-xs font-medium">
              {{ attachment.uploadProgress }}%
            </div>
          </div>
          <!-- Progress bar -->
          <div class="absolute bottom-0 left-0 right-0 h-1 bg-gray-300">
            <div
              class="h-full bg-violet-500 transition-all duration-300"
              [style.width.%]="attachment.uploadProgress"
            ></div>
          </div>
        }

        <!-- Processing overlay (server optimizing/rotating/compressing) -->
        @if (attachment.uploadState === 'processing') {
          <div
            class="absolute inset-0 bg-black/40 flex flex-col items-center justify-center gap-1"
          >
            <lucide-icon
              [img]="icons.Loader2"
              class="w-4 h-4 animate-spin text-white"
            ></lucide-icon>
            <span class="text-white text-[9px] font-medium">Processing</span>
          </div>
        }

        <!-- Error overlay -->
        @if (attachment.uploadState === 'error') {
          <div
            class="absolute inset-0 bg-red-500/20 flex items-center justify-center"
          >
            <lucide-icon
              [img]="icons.AlertCircle"
              class="w-5 h-5 text-red-500"
            ></lucide-icon>
          </div>
        }

        <!-- Remove button -->
        <button
          type="button"
          (click)="requestRemoveAttachment(attachment, $event)"
          class="absolute top-0.5 right-0.5 w-5 h-5 rounded-full bg-black/60 text-white flex items-center justify-center cursor-pointer hover:bg-black/80"
          title="Remove"
        >
          <lucide-icon [img]="icons.X" class="w-3 h-3"></lucide-icon>
        </button>
      </div>
    }
  </div>
}

<!-- Image preview modal -->
<app-image-preview-modal
  [previewItem]="previewItem"
  (closed)="closePreview()"
/>
